import { HandoverState } from "./handover";

const getHandoverApartment = (state: HandoverState): any => {
	return state.apartment;
};

const getHandoverProcess = (state: HandoverState): any => {
	return state.process;
};

const getHandoverType = (state: HandoverState): string | undefined => {
	return state.handoverType;
};

const getHandoverLoading = (state: HandoverState): boolean => {
	return state.loading;
};

const getHandoverError = (state: HandoverState): string | undefined => {
	return state.error;
};

const hasHandoverError = (state: HandoverState): boolean => {
	return !!state.error;
};

const isHandoverLoading = (state: HandoverState): boolean => {
	return state.loading;
};

const getHandoverId = (state: HandoverState): number | undefined => {
	return state.process?.id;
};

const isHandoverComplete = (state: HandoverState): boolean => {
	return !state.loading && !state.error && !!state.process;
};

export default {
	getHandoverApartment,
	getHandoverProcess,
	getHandoverType,
	getHandoverLoading,
	getHandoverError,
	hasHandoverError,
	isHandoverLoading,
	getHandoverId,
	isHandoverComplete
};
